export const UPDATE_GROUP_INTEGRATION_DRAWER_TEST_ID = "update-group-integration-drawer";
